<template>
    <BasePopup closeType="stayOnPage" width="700" @clickToClose="clickToClose">
        <div>
            <header>
                <font-awesome-icon :icon="'fa-solid '+ payment.icon" style="color: #28bc6d;"/>
                <span class="ms-2 align-middle">{{ payment.title }}</span>
            </header>
            <div>
                <div class="row">
                    <BaseSelect
                        class="col-md-6 mmb-3"
                        label="Gateway *"
                        id="gateway.id"
                        v-model="payment.gateway.id"
                        :items="payments_integrated"
                        :required="true"
                        placeholder="Selecione"
                        :page="route.name"
                    />
                    <BaseInput
                        class="col-md-6 mb-3"
                        label="Desconto"
                        type="text"
                        tag="%"
                        id="a"
                        v-model="payment.discount"
                        mask="['#', '#.#', '#.##', '##.##']"
                        :page="route.name"
                    />
                    <BaseSelect
                        class="col-12 mb-3"
                        label="Status *"
                        id="b"
                        type="text"
                        v-model="payment.status"
                        :items="statusList"
                        :required="false"
                        placeholder="Selecione"
                        :page="route.name"
                    />
                </div>
                <BaseButton @click="submit" :loading="isLoading" class="btn-success w-100 mt-4">Salvar</BaseButton>
            </div>
        </div>
    </BasePopup>
</template>

<script setup>
import { computed, onBeforeMount , ref } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from 'pinia';
import { useStoreStore } from '@/stores/store';
import { useGlobalStore } from '@/stores/global';

const globalStore = useGlobalStore();

const route = useRoute();
const router = useRouter();

const store_id = computed (function () {
    return route.params.id;
});

const statusList = ref({
  1: 'Habilitado',
  0: 'Desabilitado',
})

const isLoaded = ref(false)

const storeStore = useStoreStore();
const { payment, payments_integrated } = storeToRefs(storeStore);

onBeforeMount(() =>{
    globalStore.loader('show')
    delete globalStore.errors[route.name];
    
    if(route.name == 'storePaymentEdit'){
        if(storeStore.payment.id){
            globalStore.loader('hide')
            isLoaded.value = true;
        } else {
            storeStore.tryPayment(route.params.slug).then(() =>{
                globalStore.loader('hide')
                isLoaded.value = true;
            })
        }
    }
})

const isLoading = ref(false);

let previousPage = router.options.history.state.back;

function clickToClose() {
    router.push(previousPage)
}

function submit(){
    globalStore.loader('show')

        let params = ['discount', 'status', 'gateway'];

        storeStore.tryUpdatePayment(route.params.slug, params, route.name).then(function(success) {
            if(success){
                storeStore.tryPayments().then(function() {
                    globalStore.loader('hide');
                    router.push('/stores/' + store_id.value + '/payments')
                });
            }else {
                globalStore.loader('hide');
            }
        })
}
</script>